module.exports = __webpack_public_path__ + "img/lock-unlocked-04.0b92590d.svg";